import type React from 'react';
import { createContext, useContext } from 'react';

interface NonceContextValue {
  nonce: string | undefined;
}

const NonceContext = createContext<NonceContextValue>({ nonce: undefined });

export const useNonce = () => useContext(NonceContext);

export const NonceProvider: React.FC<{ children: React.ReactNode, nonce?: string }> = ({nonce, children}) => {
  return <NonceContext.Provider value={{ nonce }}>{children}</NonceContext.Provider>;
};
